function servicesTabInit () {

	$('.js-services-tab').on('click',  function(event) {

		var category = $(this).data('service');
		$('.js-tab-content' + '[data-service="' + category + '"]')
			.show()
			.siblings('.js-tab-content')
			.hide();

		$('.js-services-img' + '[data-service="' + category + '"]')
			.show()
			.siblings('.js-services-img')
			.hide();



		$(this).addClass('is-active')
				.siblings('.js-services-tab')
				.removeClass('is-active');

	});
}